import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

@Injectable({ providedIn: 'root' })
export class EnrolmentCommentApiService {
    constructor(
        private httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {}

    private get url(): string {
        return `${this.environmentService.getCurrentApiUrl()}/enrolment-comments`;
    }

    getCommentsByEnrolmentId(enrolmentId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/enrolment/${enrolmentId}`);
    }

    getCommentsByLearnerId(learnerId: string): Observable<any> {
        return this.httpClient.get<any>(`${this.url}/learner/${learnerId}`);
    }

    createComment(comment: any): Observable<any> {
        return this.httpClient.post<any>(this.url, comment);
    }

    updateComment(comment: any): Observable<any> {
        return this.httpClient.put<any>(this.url, comment);
    }

    deleteComment(id: string): Observable<any> {
        return this.httpClient.delete<any>(`${this.url}/${id}`);
    }

    recallComment(id: string): Observable<any> {
        return this.httpClient.put<any>(`${this.url}/recall/${id}`, {});
    }
}

